// CleanInsurance.js
// import React, { useState } from "react";
// import {
//   Container,
//   Typography,
//   Box,
//   useTheme,
//   alpha,
//   Chip,
//   Divider,
//   Paper,
//   Grid,
//   Link,
//   TextField,
//   Button,
//   MenuItem,
//   Alert,
//   CircularProgress
// } from "@mui/material";

// const Insurance = () => {
//   const theme = useTheme();

//   // Quote form state
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     businessType: "",
//     employees: "",
//     coverageType: ""
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [submitSuccess, setSubmitSuccess] = useState(false);
//   const [submitError, setSubmitError] = useState(null);

//   // Business type options
//   const businessTypes = [
//     "Solo cleaner (self‑employed)",
//     "Residential cleaning service",
//     "Commercial cleaning service",
//     "Janitorial service",
//     "Carpet cleaning",
//     "Other"
//   ];

//   // Coverage type options
//   const coverageTypes = [
//     "General liability only",
//     "General liability + tools",
//     "Full package (GL + tools + bond)",
//     "Not sure – need advice"
//   ];

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setSubmitting(true);
//     setSubmitError(null);
    
//     try {
//       // Replace this with your actual API endpoint
//       const response = await fetch('/api/insurance-quote', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData)
//       });
      
//       if (response.ok) {
//         setSubmitSuccess(true);
//         setFormData({
//           name: "",
//           email: "",
//           phone: "",
//           businessType: "",
//           employees: "",
//           coverageType: ""
//         });
//         // Reset success message after 5 seconds
//         setTimeout(() => setSubmitSuccess(false), 5000);
//       } else {
//         throw new Error('Failed to submit quote request');
//       }
//     } catch (err) {
//       setSubmitError('Unable to submit your request. Please try again or contact us directly.');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const sections = [
//     { id: "what-is", title: "What is Cleaning Insurance?" },
//     { id: "why-need", title: "Why Do Cleaners Need Insurance?" },
//     { id: "coverage-types", title: "Types of Coverage" },
//     { id: "costs", title: "How Much Does It Cost?" },
//     { id: "bonding", title: "What Is Bonding?" },
//     { id: "requirements", title: "Requirements & Legal Considerations" },
//     { id: "get-quote", title: "Get a Quote" }
//   ];

//   return (
//     <Container maxWidth="lg" sx={{ py: 8 }}>
//       {/* Header */}
//       <Box sx={{ textAlign: "center", mb: 6 }}>
//         <Chip
//           label="Cleaners"
//           sx={{
//             mb: 3,
//             background: alpha(theme.palette.primary.main, 0.1),
//             color: theme.palette.primary.dark,
//             fontWeight: 600,
//             fontSize: "0.85rem"
//           }}
//         />
//         <Typography
//           variant="h2"
//           sx={{
//             fontWeight: 700,
//             color: theme.palette.text.primary,
//             mb: 3,
//             fontSize: { xs: "2rem", md: "3rem" }
//           }}
//         >
//           Clean Insurance for Independent Cleaners
//         </Typography>
//         <Typography
//           variant="h6"
//           sx={{
//             color: theme.palette.text.secondary,
//             maxWidth: "800px",
//             mx: "auto",
//             lineHeight: 1.6,
//             fontSize: "1.1rem"
//           }}
//         >
//           Protect yourself, your equipment, and your clients with the right coverage.
//           One accident can cost thousands – don't leave your business exposed.
//         </Typography>
//       </Box>

//       <Grid container spacing={4}>
//         {/* Sidebar - Table of Contents */}
//         <Grid item xs={12} md={3}>
//           <Paper
//             elevation={0}
//             sx={{
//               position: "sticky",
//               top: 100,
//               p: 2,
//               backgroundColor: alpha(theme.palette.background.default, 0.8),
//               borderRadius: 2,
//               border: `1px solid ${alpha(theme.palette.divider, 0.1)}`
//             }}
//           >
//             <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
//               On this page
//             </Typography>
//             <Box component="ul" sx={{ pl: 2, m: 0, listStyle: "none" }}>
//               {sections.map((section) => (
//                 <Box component="li" key={section.id} sx={{ mb: 0.5 }}>
//                   <Link
//                     href={`#${section.id}`}
//                     underline="hover"
//                     sx={{
//                       fontSize: "0.85rem",
//                       color: theme.palette.text.secondary,
//                       "&:hover": { color: theme.palette.primary.main },
//                       textDecoration: "none"
//                     }}
//                   >
//                     {section.title}
//                   </Link>
//                 </Box>
//               ))}
//             </Box>
//           </Paper>
//         </Grid>

//         {/* Main content */}
//         <Grid item xs={12} md={9}>
//           <Paper
//             elevation={0}
//             sx={{
//               p: { xs: 2, md: 4 },
//               borderRadius: 3,
//               backgroundColor: theme.palette.background.paper,
//               border: `1px solid ${alpha(theme.palette.divider, 0.1)}`
//             }}
//           >
//             {/* 1. What is Cleaning Insurance? */}
//             <Box id="what-is" sx={{ scrollMarginTop: 80, mb: 4 }}>
//               <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
//                 What is Cleaning Insurance?
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 Cleaning insurance (also known as housekeeping insurance) is a suite of policies 
//                 designed to protect cleaning professionals from financial losses caused by accidents, 
//                 property damage, theft, and injuries that can occur while working[reference:0]. Whether you 
//                 work independently or as part of a team, cleaning insurance covers the unexpected costs 
//                 that could otherwise derail your business.
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 Without it, even a minor mistake—like spilling a bucket of soapy water on a client’s 
//                 hardwood floor—could leave you personally responsible for thousands of dollars in 
//                 repair costs[reference:1].
//               </Typography>
//               <Typography variant="body1">
//                 Self‑employed cleaners carry all the risk themselves, with no employer policy and 
//                 no one else to absorb a claim. The right coverage mix protects your income and your 
//                 assets[reference:2].
//               </Typography>
//             </Box>

//             <Divider sx={{ my: 3 }} />

//             {/* 2. Why Do Cleaners Need Insurance? */}
//             <Box id="why-need" sx={{ scrollMarginTop: 80, mb: 4 }}>
//               <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
//                 Why Do Cleaners Need Insurance?
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 Every cleaner faces three common risks the moment they’re on the job: people getting hurt, 
//                 damage to a client’s property, and lost or broken cleaning equipment[reference:3]. 
//                 Consider these real‑world scenarios:
//               </Typography>
//               <Box component="ul" sx={{ pl: 2, mb: 2 }}>
//                 <li><Typography variant="body1">A client slips on a freshly mopped floor and breaks their wrist – medical bills can reach $15,000 for a simple slip‑and‑fall[reference:4].</Typography></li>
//                 <li><Typography variant="body1">Your vacuum snags an heirloom rug, tearing it and ruining the motor – replacing both could cost thousands[reference:5].</Typography></li>
//                 <li><Typography variant="body1">Your cleaning equipment is stolen from your locked vehicle – replacing it comes out of your pocket[reference:6].</Typography></li>
//               </Box>
//               <Typography variant="body1" paragraph>
//                 Most commercial clients and homeowners will require proof of insurance before hiring you, 
//                 making it essential for growing your business[reference:7].
//               </Typography>
//               <Typography variant="body1">
//                 Beyond just playing defense, having the right insurance helps you win more clients. 
//                 It's a sign of professionalism and shows you’re a serious business owner[reference:8].
//               </Typography>
//             </Box>

//             <Divider sx={{ my: 3 }} />

//             {/* 3. Types of Coverage */}
//             <Box id="coverage-types" sx={{ scrollMarginTop: 80, mb: 4 }}>
//               <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
//                 Types of Coverage Every Cleaner Should Consider
//               </Typography>
              
//               <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
//                 General Liability Insurance
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 This is the single most important policy for house cleaners[reference:9]. It covers third‑party 
//                 bodily injury, property damage, and legal fees if a client sues you[reference:10]. Average cost: 
//                 <strong> $30–$50 per month</strong>[reference:11][reference:12].
//               </Typography>

//               <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
//                 Tools & Equipment Coverage (Inland Marine)
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 Protects your industrial vacuums, steamers, and other expensive gear from theft, damage, 
//                 or loss, whether at a client’s site, in your vehicle, or in storage[reference:13]. 
//                 Median cost: <strong>$21–$27 per month</strong>[reference:14].
//               </Typography>

//               <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
//                 Janitorial Bond (Fidelity Bond)
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 A janitorial bond is not insurance – it’s a surety bond that protects your clients 
//                 against theft by you or your employees. It covers accusations of theft or dishonesty, 
//                 which are common in this industry[reference:15]. Many clients require a bond before hiring 
//                 you[reference:16]. Costs: <strong>$11–$33 per month</strong> depending on coverage amount.
//               </Typography>

//               <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
//                 Workers’ Compensation
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 If you hire even one employee, most states require workers’ comp. It covers medical bills 
//                 and lost wages if an employee is injured on the job[reference:17]. Average cost: 
//                 <strong> $92–$143 per month</strong>[reference:18][reference:19].
//               </Typography>

//               <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
//                 Commercial Auto Insurance
//               </Typography>
//               <Typography variant="body1">
//                 If you drive your personal vehicle to client locations daily, your personal auto policy 
//                 likely won’t cover business use. Commercial auto covers accidents between job sites[reference:20]. 
//                 Average cost: <strong>$173 per month</strong>[reference:21].
//               </Typography>
//             </Box>

//             <Divider sx={{ my: 3 }} />

//             {/* 4. How Much Does It Cost? */}
//             <Box id="costs" sx={{ scrollMarginTop: 80, mb: 4 }}>
//               <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
//                 How Much Does Cleaning Insurance Cost?
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 Insurance for house cleaners is relatively inexpensive compared to other trades. 
//                 A solo cleaner can get general liability for <strong>under $20/month</strong> from some 
//                 carriers[reference:22]. Here are average costs based on real data:
//               </Typography>
//               <Box component="ul" sx={{ pl: 2, mb: 2 }}>
//                 <li><Typography variant="body1"><strong>General liability:</strong> $30–$50 per month ($354–$603 per year)[reference:23][reference:24]</Typography></li>
//                 <li><Typography variant="body1"><strong>Tools & equipment:</strong> $21–$27 per month ($250–$324 per year)[reference:25][reference:26]</Typography></li>
//                 <li><Typography variant="body1"><strong>Workers’ compensation:</strong> $92–$143 per month ($1,106–$1,711 per year)[reference:27][reference:28]</Typography></li>
//                 <li><Typography variant="body1"><strong>Janitorial bond (jump bond):</strong> $11–$33 per month ($100–$400 per year)[reference:29][reference:30]</Typography></li>
//               </Box>
//               <Typography variant="body1">
//                 Your final premium depends on your location, number of employees, types of properties 
//                 you clean (residential vs. commercial), claims history, and coverage limits[reference:31].
//               </Typography>
//             </Box>

//             <Divider sx={{ my: 3 }} />

//             {/* 5. What Is Bonding? */}
//             <Box id="bonding" sx={{ scrollMarginTop: 80, mb: 4 }}>
//               <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
//                 What Is Bonding and Do I Need It?
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 A janitorial bond (also called a fidelity bond or cleaning bond) is a financial guarantee 
//                 that protects your clients if you or your employees steal from them. Unlike insurance, 
//                 a bond does not protect your business – it protects your customers[reference:32].
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 Many property managers, commercial building owners, and corporate clients require a surety 
//                 bond alongside proof of insurance before awarding a contract[reference:33]. Being “licensed, 
//                 bonded, and insured” is standard language in commercial cleaning contracts[reference:34].
//               </Typography>
//               <Typography variant="body1">
//                 For example, a business that wants $100,000 in coverage can secure a janitorial bond for 
//                 around $300–$400 per year. Some bonds can even be secured for as low as $100 per year[reference:35].
//               </Typography>
//             </Box>

//             <Divider sx={{ my: 3 }} />

//             {/* 6. Requirements & Legal Considerations */}
//             <Box id="requirements" sx={{ scrollMarginTop: 80, mb: 4 }}>
//               <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
//                 Requirements & Legal Considerations
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 <strong>Licensing:</strong> Most states require a general business license to operate legally. 
//                 You may also need a vendor’s license to collect sales tax on cleaning supplies[reference:36].
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 <strong>Client Requirements:</strong> Most commercial clients require a certificate of insurance 
//                 before awarding a contract[reference:37]. Many also require a janitorial surety bond[reference:38].
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 <strong>Minimum Coverage Limits:</strong> Commercial contracts often specify a minimum amount 
//                 of general liability coverage – commonly $1 million per occurrence[reference:39].
//               </Typography>
//               <Typography variant="body1">
//                 <strong>State Mandates:</strong> Workers’ compensation is mandatory in most states once you hire 
//                 an employee. Commercial auto may be required if your business owns or leases vehicles[reference:40].
//               </Typography>
//             </Box>

//             <Divider sx={{ my: 3 }} />

//             {/* 7. Get a Quote */}
//             <Box id="get-quote" sx={{ scrollMarginTop: 80, mb: 2 }}>
//               <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
//                 Get a Free Insurance Quote
//               </Typography>
//               <Typography variant="body1" paragraph>
//                 Protect your cleaning business with the right coverage. Fill out the form below and we’ll 
//                 connect you with trusted insurance providers that specialize in cleaning business insurance.
//               </Typography>

//               {submitSuccess && (
//                 <Alert severity="success" sx={{ mb: 3 }}>
//                   Thank you! A FreshSweeper representative will contact you within 1 business day with 
//                   personalized insurance options.
//                 </Alert>
//               )}

//               {submitError && (
//                 <Alert severity="error" sx={{ mb: 3 }}>
//                   {submitError}
//                 </Alert>
//               )}

//               <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Full Name"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       required
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       fullWidth
//                       label="Email Address"
//                       name="email"
//                       type="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       required
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       fullWidth
//                       label="Phone Number"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                       required
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       select
//                       fullWidth
//                       label="Business Type"
//                       name="businessType"
//                       value={formData.businessType}
//                       onChange={handleInputChange}
//                       required
//                     >
//                       {businessTypes.map((option) => (
//                         <MenuItem key={option} value={option}>
//                           {option}
//                         </MenuItem>
//                       ))}
//                     </TextField>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       select
//                       fullWidth
//                       label="Number of Employees (including yourself)"
//                       name="employees"
//                       value={formData.employees}
//                       onChange={handleInputChange}
//                       required
//                     >
//                       <MenuItem value="1">Just me (solo)</MenuItem>
//                       <MenuItem value="2-5">2-5 employees</MenuItem>
//                       <MenuItem value="6-10">6-10 employees</MenuItem>
//                       <MenuItem value="11+">11+ employees</MenuItem>
//                     </TextField>
//                   </Grid>
//                   <Grid item xs={12}>
//                     <TextField
//                       select
//                       fullWidth
//                       label="Coverage Type Interest"
//                       name="coverageType"
//                       value={formData.coverageType}
//                       onChange={handleInputChange}
//                       required
//                     >
//                       {coverageTypes.map((option) => (
//                         <MenuItem key={option} value={option}>
//                           {option}
//                         </MenuItem>
//                       ))}
//                     </TextField>
//                   </Grid>
//                   <Grid item xs={12}>
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       fullWidth
//                       disabled={submitting}
//                       sx={{
//                         py: 1.5,
//                         backgroundColor: theme.palette.primary.main,
//                         '&:hover': { backgroundColor: theme.palette.primary.dark }
//                       }}
//                     >
//                       {submitting ? <CircularProgress size={24} color="inherit" /> : "Get a Quote"}
//                     </Button>
//                   </Grid>
//                 </Grid>
//               </Box>

//               <Typography variant="caption" sx={{ display: 'block', mt: 2, textAlign: 'center', color: 'text.secondary' }}>
//                 By submitting this form, you agree to receive information about insurance options.
//                 We’ll never share your information with third parties without your consent.
//               </Typography>
//             </Box>
//           </Paper>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default Insurance;



import React, { useState } from "react";
import {
  Container,
  Typography,
  Box,
  useTheme,
  alpha,
  Chip,
  Divider,
  Paper,
  Grid,
  Link,
  TextField,
  Button,
  MenuItem,
  Alert,
  CircularProgress
} from "@mui/material";

const Insurance = () => {
  const theme = useTheme();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    businessType: "",
    employees: "",
    coverageType: ""
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const businessTypes = [
    "Solo cleaner (self‑employed)",
    "Residential cleaning service",
    "Commercial cleaning service",
    "Janitorial service",
    "Carpet cleaning",
    "Other"
  ];

  const coverageTypes = [
    "General liability only",
    "General liability + tools",
    "Full package (GL + tools + bond)",
    "Not sure – need advice"
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitError(null);
    
    try {
      const response = await fetch('/api/insurance-quote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      
      if (response.ok) {
        setSubmitSuccess(true);
        setFormData({
          name: "",
          email: "",
          phone: "",
          businessType: "",
          employees: "",
          coverageType: ""
        });
        setTimeout(() => setSubmitSuccess(false), 5000);
      } else {
        throw new Error('Failed to submit quote request');
      }
    } catch (err) {
      setSubmitError('Unable to submit your request. Please try again or contact us directly.');
    } finally {
      setSubmitting(false);
    }
  };

  const sections = [
    { id: "what-is", title: "What is Cleaning Insurance?" },
    { id: "why-need", title: "Why Do Cleaners Need Insurance?" },
    { id: "coverage-types", title: "Types of Coverage" },
    { id: "costs", title: "How Much Does It Cost?" },
    { id: "bonding", title: "What Is Bonding?" },
    { id: "requirements", title: "Requirements & Legal Considerations" },
    { id: "get-quote", title: "Get a Quote" }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Chip
          label="Cleaners"
          sx={{
            mb: 3,
            background: alpha(theme.palette.primary.main, 0.1),
            color: theme.palette.primary.dark,
            fontWeight: 600,
            fontSize: "0.85rem"
          }}
        />
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
            mb: 3,
            fontSize: { xs: "2rem", md: "3rem" }
          }}
        >
          Clean Insurance for Independent Cleaners
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: theme.palette.text.secondary,
            maxWidth: "800px",
            mx: "auto",
            lineHeight: 1.6,
            fontSize: "1.1rem"
          }}
        >
          Protect yourself, your equipment, and your clients with the right coverage.
          One accident can cost thousands – don't leave your business exposed.
        </Typography>
      </Box>

      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          <Paper
            elevation={0}
            sx={{
              position: "sticky",
              top: 100,
              p: 2,
              backgroundColor: alpha(theme.palette.background.default, 0.8),
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`
            }}
          >
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
              On this page
            </Typography>
            <Box component="ul" sx={{ pl: 2, m: 0, listStyle: "none" }}>
              {sections.map((section) => (
                <Box component="li" key={section.id} sx={{ mb: 0.5 }}>
                  <Link
                    href={`#${section.id}`}
                    underline="hover"
                    sx={{
                      fontSize: "0.85rem",
                      color: theme.palette.text.secondary,
                      "&:hover": { color: theme.palette.primary.main },
                      textDecoration: "none"
                    }}
                  >
                    {section.title}
                  </Link>
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12} md={9}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, md: 4 },
              borderRadius: 3,
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`
            }}
          >
            <Box id="what-is" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                What is Cleaning Insurance?
              </Typography>
              <Typography variant="body1" paragraph>
                Cleaning insurance (also known as housekeeping insurance) is a suite of policies 
                designed to protect cleaning professionals from financial losses caused by accidents, 
                property damage, theft, and injuries that can occur while working. Whether you 
                work independently or as part of a team, cleaning insurance covers the unexpected costs 
                that could otherwise derail your business.
              </Typography>
              <Typography variant="body1" paragraph>
                Without it, even a minor mistake—like spilling a bucket of soapy water on a client’s 
                hardwood floor—could leave you personally responsible for thousands of dollars in 
                repair costs.
              </Typography>
              <Typography variant="body1">
                Self‑employed cleaners carry all the risk themselves, with no employer policy and 
                no one else to absorb a claim. The right coverage mix protects your income and your 
                assets.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Box id="why-need" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                Why Do Cleaners Need Insurance?
              </Typography>
              <Typography variant="body1" paragraph>
                Every cleaner faces three common risks the moment they’re on the job: people getting hurt, 
                damage to a client’s property, and lost or broken cleaning equipment. 
                Consider these real‑world scenarios:
              </Typography>
              <Box component="ul" sx={{ pl: 2, mb: 2 }}>
                <li><Typography variant="body1">A client slips on a freshly mopped floor and breaks their wrist – medical bills can reach $15,000 for a simple slip‑and‑fall.</Typography></li>
                <li><Typography variant="body1">Your vacuum snags an heirloom rug, tearing it and ruining the motor – replacing both could cost thousands.</Typography></li>
                <li><Typography variant="body1">Your cleaning equipment is stolen from your locked vehicle – replacing it comes out of your pocket.</Typography></li>
              </Box>
              <Typography variant="body1" paragraph>
                Most commercial clients and homeowners will require proof of insurance before hiring you, 
                making it essential for growing your business.
              </Typography>
              <Typography variant="body1">
                Beyond just playing defense, having the right insurance helps you win more clients. 
                It's a sign of professionalism and shows you’re a serious business owner.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Box id="coverage-types" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                Types of Coverage Every Cleaner Should Consider
              </Typography>
              
              <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
                General Liability Insurance
              </Typography>
              <Typography variant="body1" paragraph>
                This is the single most important policy for house cleaners. It covers third‑party 
                bodily injury, property damage, and legal fees if a client sues you. Average cost: 
                <strong> $30–$50 per month</strong>.
              </Typography>

              <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
                Tools & Equipment Coverage (Inland Marine)
              </Typography>
              <Typography variant="body1" paragraph>
                Protects your industrial vacuums, steamers, and other expensive gear from theft, damage, 
                or loss, whether at a client’s site, in your vehicle, or in storage. 
                Median cost: <strong>$21–$27 per month</strong>.
              </Typography>

              <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
                Janitorial Bond (Fidelity Bond)
              </Typography>
              <Typography variant="body1" paragraph>
                A janitorial bond is not insurance – it’s a surety bond that protects your clients 
                against theft by you or your employees. It covers accusations of theft or dishonesty, 
                which are common in this industry. Many clients require a bond before hiring 
                you. Costs: <strong>$11–$33 per month</strong> depending on coverage amount.
              </Typography>

              <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
                Workers’ Compensation
              </Typography>
              <Typography variant="body1" paragraph>
                If you hire even one employee, most states require workers’ comp. It covers medical bills 
                and lost wages if an employee is injured on the job. Average cost: 
                <strong> $92–$143 per month</strong>.
              </Typography>

              <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
                Commercial Auto Insurance
              </Typography>
              <Typography variant="body1">
                If you drive your personal vehicle to client locations daily, your personal auto policy 
                likely won’t cover business use. Commercial auto covers accidents between job sites. 
                Average cost: <strong>$173 per month</strong>.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Box id="costs" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                How Much Does Cleaning Insurance Cost?
              </Typography>
              <Typography variant="body1" paragraph>
                Insurance for house cleaners is relatively inexpensive compared to other trades. 
                A solo cleaner can get general liability for <strong>under $20/month</strong> from some 
                carriers. Here are average costs based on real data:
              </Typography>
              <Box component="ul" sx={{ pl: 2, mb: 2 }}>
                <li><Typography variant="body1"><strong>General liability:</strong> $30–$50 per month ($354–$603 per year)</Typography></li>
                <li><Typography variant="body1"><strong>Tools & equipment:</strong> $21–$27 per month ($250–$324 per year)</Typography></li>
                <li><Typography variant="body1"><strong>Workers’ compensation:</strong> $92–$143 per month ($1,106–$1,711 per year)</Typography></li>
                <li><Typography variant="body1"><strong>Janitorial bond (jump bond):</strong> $11–$33 per month ($100–$400 per year)</Typography></li>
              </Box>
              <Typography variant="body1">
                Your final premium depends on your location, number of employees, types of properties 
                you clean (residential vs. commercial), claims history, and coverage limits.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Box id="bonding" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                What Is Bonding and Do I Need It?
              </Typography>
              <Typography variant="body1" paragraph>
                A janitorial bond (also called a fidelity bond or cleaning bond) is a financial guarantee 
                that protects your clients if you or your employees steal from them. Unlike insurance, 
                a bond does not protect your business – it protects your customers.
              </Typography>
              <Typography variant="body1" paragraph>
                Many property managers, commercial building owners, and corporate clients require a surety 
                bond alongside proof of insurance before awarding a contract. Being “licensed, 
                bonded, and insured” is standard language in commercial cleaning contracts.
              </Typography>
              <Typography variant="body1">
                For example, a business that wants $100,000 in coverage can secure a janitorial bond for 
                around $300–$400 per year. Some bonds can even be secured for as low as $100 per year.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Box id="requirements" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                Requirements & Legal Considerations
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Licensing:</strong> Most states require a general business license to operate legally. 
                You may also need a vendor’s license to collect sales tax on cleaning supplies.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Client Requirements:</strong> Most commercial clients require a certificate of insurance 
                before awarding a contract. Many also require a janitorial surety bond.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Minimum Coverage Limits:</strong> Commercial contracts often specify a minimum amount 
                of general liability coverage – commonly $1 million per occurrence.
              </Typography>
              <Typography variant="body1">
                <strong>State Mandates:</strong> Workers’ compensation is mandatory in most states once you hire 
                an employee. Commercial auto may be required if your business owns or leases vehicles.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Box id="get-quote" sx={{ scrollMarginTop: 80, mb: 2 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                Get a Free Insurance Quote
              </Typography>
              <Typography variant="body1" paragraph>
                Protect your cleaning business with the right coverage. Fill out the form below and we’ll 
                connect you with trusted insurance providers that specialize in cleaning business insurance.
              </Typography>

              {submitSuccess && (
                <Alert severity="success" sx={{ mb: 3 }}>
                  Thank you! A FreshSweeper representative will contact you within 1 business day with 
                  personalized insurance options.
                </Alert>
              )}

              {submitError && (
                <Alert severity="error" sx={{ mb: 3 }}>
                  {submitError}
                </Alert>
              )}

              <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Full Name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Email Address"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Phone Number"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      required
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      select
                      fullWidth
                      label="Business Type"
                      name="businessType"
                      value={formData.businessType}
                      onChange={handleInputChange}
                      required
                    >
                      {businessTypes.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      select
                      fullWidth
                      label="Number of Employees (including yourself)"
                      name="employees"
                      value={formData.employees}
                      onChange={handleInputChange}
                      required
                    >
                      <MenuItem value="1">Just me (solo)</MenuItem>
                      <MenuItem value="2-5">2-5 employees</MenuItem>
                      <MenuItem value="6-10">6-10 employees</MenuItem>
                      <MenuItem value="11+">11+ employees</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      select
                      fullWidth
                      label="Coverage Type Interest"
                      name="coverageType"
                      value={formData.coverageType}
                      onChange={handleInputChange}
                      required
                    >
                      {coverageTypes.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      disabled={submitting}
                      sx={{
                        py: 1.5,
                        backgroundColor: theme.palette.primary.main,
                        '&:hover': { backgroundColor: theme.palette.primary.dark }
                      }}
                    >
                      {submitting ? <CircularProgress size={24} color="inherit" /> : "Get a Quote"}
                    </Button>
                  </Grid>
                </Grid>
              </Box>

              <Typography variant="caption" sx={{ display: 'block', mt: 2, textAlign: 'center', color: 'text.secondary' }}>
                By submitting this form, you agree to receive information about insurance options.
                We’ll never share your information with third parties without your consent.
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Insurance;